import React, { useState, useEffect, useRef } from 'react';

function StatsCounter() {
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState({ projects: 0, clients: 0, years: 0, satisfaction: 0 });
  const sectionRef = useRef(null);

  const finalStats = {
    projects: 250,
    clients: 150,
    years: 8,
    satisfaction: 99
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible) {
      const duration = 2000; // 2 seconds
      const steps = 60;
      const stepDuration = duration / steps;

      Object.keys(finalStats).forEach((key) => {
        const finalValue = finalStats[key];
        const increment = finalValue / steps;
        let currentValue = 0;

        const timer = setInterval(() => {
          currentValue += increment;
          if (currentValue >= finalValue) {
            currentValue = finalValue;
            clearInterval(timer);
          }
          setCounts(prev => ({ ...prev, [key]: Math.floor(currentValue) }));
        }, stepDuration);
      });
    }
  }, [isVisible]);

  return (
    <div 
      ref={sectionRef}
      className="relative py-16 overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1523287562758-66c7fc58967f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHN1Y2Nlc3N8ZW58MHx8fHwxNzQ5MDQwMTIzfDA&ixlib=rb-4.1.0&q=80&w=1080')`
        }}
      >
        <div className="absolute inset-0 bg-blue-900 bg-opacity-85"></div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Our Impact in Numbers</h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            These numbers represent our commitment to excellence and our clients' success
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center text-white">
            <div className="text-5xl font-bold mb-2">{counts.projects}+</div>
            <div className="text-xl text-blue-100">Projects Completed</div>
          </div>
          
          <div className="text-center text-white">
            <div className="text-5xl font-bold mb-2">{counts.clients}+</div>
            <div className="text-xl text-blue-100">Happy Clients</div>
          </div>
          
          <div className="text-center text-white">
            <div className="text-5xl font-bold mb-2">{counts.years}+</div>
            <div className="text-xl text-blue-100">Years Experience</div>
          </div>
          
          <div className="text-center text-white">
            <div className="text-5xl font-bold mb-2">{counts.satisfaction}%</div>
            <div className="text-xl text-blue-100">Client Satisfaction</div>
          </div>
        </div>
      </div>
      
      {/* Image Attribution */}
      <span className="group/attribution absolute bottom-2 right-2 text-[10px] text-white outline outline-1 outline-white px-[6px] rounded-lg z-10 min-w-4 max-w-[calc(100%-16px)] h-4 leading-4 truncate text-center shadow">
        <span className="block drop-shadow-md group-hover/attribution:hidden">i</span>
        <span className="hidden drop-shadow-md group-hover/attribution:block">
          Image on{' '}
          <a
            href="https://unsplash.com?utm_source=Maker%20AI&utm_medium=referral"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#fff', textDecoration: 'none' }}
          >
            Unsplash
          </a>{' '}
          by{' '}
          <a
            href="https://unsplash.com/@nullplus?utm_source=makerdevi&utm_medium=referral"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#fff', textDecoration: 'none' }}
          >
            Razvan Chisu
          </a>
        </span>
      </span>
    </div>
  );
}

export default StatsCounter;